// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{height:100%;margin:0;padding:0;background-color:transparent;background-repeat:no-repeat;background-position:center center;background-size:cover;overflow-x:hidden}\n", ""]);
// Exports
module.exports = exports;
